import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

interface DocumentSectionProps {
  namespace: string;
  id: string;
  titleKey: string;
  descriptionKey?: string;
  children: ReactNode;
}

export const DocumentSection: React.FC<DocumentSectionProps> = ({
  namespace,
  id,
  titleKey,
  descriptionKey,
  children,
}) => {
  const { t } = useTranslation(namespace);

  return (
    <section id={id} className="scroll-mt-28">
      <div className="space-y-2 mb-6">
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900">{t(titleKey)}</h2>
        {descriptionKey && <p className="text-slate-600">{t(descriptionKey)}</p>}
      </div>
      <div className="space-y-5">{children}</div>
    </section>
  );
};